import React, { useCallback } from 'react';

const readFileAsBase64 = file => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  return new Promise(resolve => {
    reader.onloadend = () => resolve(reader.result);
  });
};

const readImg = async files => {
  if (files === null)
    return {
      ext: '',
      image: null,
      error: 'hasNoFiles',
    };

  const img = files?.length ? files[0] : files;

  const result = await readFileAsBase64(img);

  const ext = img.type.split('/')[1] || '';

  return {
    ext: ext === 'jpeg' ? 'jpg' : ext,
    image: img,
    error: null,
    base64: result,
  };
};

const useImageInput = () =>
  useCallback(async files => {
    const imageData = await readImg(files);
    return imageData;
  }, []);

export default useImageInput;
